import { Module } from "vuex";
import { State } from "@/store/modules/page_category/state";
import Mutations from "@/store/modules/page_category/mutations";
import Getters from "@/store/modules/page_category/getters";
import Actions from "@/store/modules/page_category/actions";

export class PageCategory implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
